export function vapidPublicKey(): string {
  return String(process.env.VITE_VAPID_PUBLIC_KEY || '').trim()
}

export function subscriptionDocId(endpoint: string): string {
  let hash = 0
  for (let i = 0; i < endpoint.length; i += 1) {
    hash = (hash << 5) - hash + endpoint.charCodeAt(i)
    hash |= 0
  }
  return `ep_${Math.abs(hash).toString(36)}`
}

export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = window.atob(base64)
  const output = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i += 1) {
    output[i] = raw.charCodeAt(i)
  }
  return output
}

export type StoredPushSubscription = {
  endpoint: string
  keys: { p256dh: string; auth: string }
  userAgent: string
  updatedAt: string
}

export function toStoredSubscription(subscription: PushSubscription): StoredPushSubscription | null {
  const json = subscription.toJSON()
  if (!json.endpoint || !json.keys?.p256dh || !json.keys?.auth) return null
  return {
    endpoint: json.endpoint,
    keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
    userAgent: typeof navigator === 'undefined' ? '' : navigator.userAgent,
    updatedAt: new Date().toISOString(),
  }
}
